import React from "react";
import "./InfoMessage.scss";
import {strings} from "../../strings/strings";

export const AdditionalCovarageCascoMessage = (isSmartDrive) => {
    return (
        <div>
            <span className={'info-message-grey'}>{isSmartDrive ? strings.additionalCoverageCascoMessageSmartDrive : strings.additionalCoverageCascoMessage}</span>
        </div>
    )
};